import { BaseDrawArgs, BaseGridCell } from '@glideapps/glide-data-grid'

import { isValidUrl } from '@makyoapp/makyo-common'

import { THUMB_SQUARE } from '@/shared/constants'

import { roundedRect } from './draw-fns'

export const itemMargin = 2

const fallbackImage = new Image()
fallbackImage.src = THUMB_SQUARE

export function drawImage(
  args: BaseDrawArgs,
  data: string | string[],
  rounding: number,
  contentAlign?: BaseGridCell['contentAlign']
) {
  const { rect, col, row, theme, ctx, imageLoader } = args
  const { x, y, height: h, width: w } = rect

  const imgSize = Math.min(h, w) - theme.cellVerticalPadding * 2 // Ensuring the image is square
  const images: (HTMLImageElement | ImageBitmap)[] = []
  let totalWidth = 0
  const dataImages = Array.isArray(data) ? data : [data]

  // Load images
  for (let index = 0; index < dataImages.length; index++) {
    const i = dataImages[index]

    if (i.length === 0) continue

    // const isMakyoImage = !/unsplash\.|^blob:http|youtube\.com/.test(i)
    // let img = imageLoader.loadOrGetImage(isMakyoImage ? GetImageMetdataLink(i, ImageMetadata.XS) : i, col, row)

    let img = imageLoader.loadOrGetImage(i, col, row)

    if (img === undefined && i.length !== 0) {
      const newImg = new Image()
      newImg.src = isValidUrl(i) ? i : THUMB_SQUARE

      newImg.onerror = () => {
        newImg.src = THUMB_SQUARE
      }

      img = newImg
    }

    if (img === undefined) {
      continue
    }

    images[index] = img
    totalWidth += imgSize + itemMargin
  }

  if (totalWidth === 0) return
  totalWidth -= itemMargin

  let drawX = x + theme.cellHorizontalPadding
  if (contentAlign === 'right') drawX = Math.floor(x + w - theme.cellHorizontalPadding - totalWidth)
  else if (contentAlign === 'center') drawX = Math.floor(x + w / 2 - totalWidth / 2)

  // Render each image as a rounded square with 1:1 aspect ratio
  for (const img of images) {
    if (img === undefined) continue // Skip sparse array elements

    if (rounding > 0) {
      ctx.beginPath()
      // Draw the rounded rectangle (square) with the imgSize as width and height
      roundedRect(ctx, drawX, y + theme.cellVerticalPadding, imgSize, imgSize, rounding)
      ctx.save()
      ctx.clip()
    }

    // Ensure the image is drawn as a 1:1 aspect ratio square by using imgSize for both width and height
    ctx.drawImage(img, drawX, y + theme.cellVerticalPadding, imgSize, imgSize)

    if (rounding > 0) {
      ctx.restore()
    }

    drawX += imgSize + itemMargin // Move to the next position
  }
}
